export default "__VITE_ASSET__j1MqxTSV__"